// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_1 from '/Users/zouhaifeng/Downloads/whitemay-insurance-yibaochat-web- 2/src/models/apiModel';
import model_3 from '/Users/zouhaifeng/Downloads/whitemay-insurance-yibaochat-web- 2/src/models/sessionModel';
import model_2 from '/Users/zouhaifeng/Downloads/whitemay-insurance-yibaochat-web- 2/src/models/authModel';

export const models = {
model_1: { namespace: 'apiModel', model: model_1 },
model_3: { namespace: 'sessionModel', model: model_3 },
model_2: { namespace: 'authModel', model: model_2 },
} as const
